var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00044 18.1668C5.74807 18.1667 4.52461 17.7903 3.4887 17.0865C2.45279 16.3828 1.6522 15.384 1.19073 14.2197C0.72927 13.0555 0.628218 11.7794 0.90068 10.5571C1.17314 9.33469 1.80655 8.22235 2.71878 7.36429C3.83711 6.31179 6.58378 4.41679 6.16711 0.250122C11.1671 3.58346 13.6671 6.91679 8.66711 11.9168C9.50044 11.9168 10.7504 11.9168 12.8338 9.85845C13.0588 10.5026 13.2504 11.1951 13.2504 11.9168C13.2504 13.5744 12.592 15.1641 11.4199 16.3362C10.2478 17.5083 8.65805 18.1668 7.00044 18.1668Z",
    fill: "#913FF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleFire);
export default __webpack_public_path__ + "static/media/purpleFire.65709a96f142bd085da68cae1a35e132.svg";
export { ForwardRef as ReactComponent };